import type { IconData } from '@stacksjs/iconify-core'

export const basicUiHide: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m0 1l1-1l2.88 2.88C4.997 2.074 6.366 1.5 8 1.5c5.5 0 8 6.5 8 6.5s-.897 2.332-2.798 4.202L16 15l-1 1zm7.177 5.177l2.646 2.646a2 2 0 0 0-2.646-2.646\" clip-rule=\"evenodd\"/><path fill=\"currentColor\" d=\"M1.854 4.854C.6 6.444 0 8 0 8s2.5 6.5 8 6.5a6.7 6.7 0 0 0 2.863-.637z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiHide
